import type { DoorType, GarageDoorType } from "../types/C1_ModelTypes";

export const C1_DOOR_TYPE_LABELS: Record<DoorType, { de: string; en: string }> = {
  interior: { de: "Innentür", en: "Internal door" },
  passage: { de: "Durchgang", en: "Passage" },
  entrance: { de: "Haustür", en: "Entrance door" },
  garden: { de: "Gartentür", en: "Garden door" },
};

export const C1_GARAGE_DOOR_TYPE_LABELS: Record<GarageDoorType, { de: string; en: string }> = {
  roller: { de: "Rolltor", en: "Roller door" },
  sectional: { de: "Sektionaltor", en: "Sectional door" },
  "up-and-over": { de: "Schwingtor", en: "Up-and-over door" },
};
